const FORM_EVENT = 'PetCareReminders Form';
const FORM_NAME = 'Product Reminder';

export const formStart = () => {
    console.log("Form started");

    if (typeof window === 'undefined' || !window.WSC || !window.WSC.modules || !window.WSC.modules.instatag) return;

    // ES6
    const event = WSC.modules.instatag.createEvent('event12');

    // setting some values here
    event.getEvar('eVar31').value = FORM_EVENT;
    event.getEvar('eVar32').value = FORM_NAME;

    // send it
    event.fire();
};

export const formSubmit = (value) => {
     console.log("Form submitted: ", value);

     if (typeof window === 'undefined' || !window.WSC || !window.WSC.modules || !window.WSC.modules.instatag) return;

    // ES6
    const event = WSC.modules.instatag.createEvent('event13');

    // setting some values here
    event.getEvar('eVar31').value = FORM_EVENT;
    event.getEvar('eVar32').value = FORM_NAME;
    event.getEvar('eVar33').value = value;

    // send it
    event.fire();
};

